export default __webpack_public_path__ + "static/media/section3_1_1.71d0c7ea.png";